<template>
  <div id="modal-indexes">
    <h3 class="title-modal">Add Index</h3>

    <!-- Column Fields -->
    <div class="wrap-column-field">
      <div
        v-for="(data, index) in dataSetup"
        :key="`field-column-${index}`"
        class="columns"
      >
        <p class="mb-1">Column</p>
        <div
          :class="{'error-input' : $v.dataSetup.$error && !$v.dataSetup.$model[index].column}"
          class="d-flex align-items-center"
        >
          <j-single-select
            v-model="data.column"
            :error-required="false"
            :options="columns"
            :placeholder="'Select Column'"
            @input="validationOptions($event, index)"
          />
          <div
            :id="`column-sort-${index}`"
            :class="{'mr-4': index === 0}"
            class="definition"
            @click="openDropdownSort(index)"
          >
            <div class="d-flex align-items-center">
              <img
                :src="require(`@/assets/icon/${data.type === 1 ? 'asc' : 'desc'}.svg`)"
              >
              <span>{{ data.type === 1 ? 'ASC' : 'DESC' }}</span>
            </div>
            <i class="fa fa-chevron-down" />
          </div>
          <i
            v-if="index > 0"
            class="fa fa-trash delete-column"
            @click="dataSetup.splice(index, 1)"
          />
        </div>

        <!-- Popover sort -->
        <b-popover
          :ref="`column-sort-${index}`"
          :target="`column-sort-${index}`"
          triggers="manual"
          placement="bottom"
          container="modal-indexes"
        >
          <div
            v-for="sort in sorts"
            :key="sort.id"
            class="sort"
            @click="data.type = sort.id; openDropdownSort(index)"
          >
            <img :src="require(`@/assets/icon/${sort.text.toLowerCase()}.svg`)">
            <span>{{ sort.text }}</span>
          </div>
        </b-popover>
      </div>
    </div>

    <!-- Add Field -->
    <div
      class="add-field mt-2 mb-4"
      @click="addField"
    >
      <img src="@/assets/icon/add.png">
      Add
    </div>

    <div class="d-flex align-items-center justify-content-end">
      <button
        class="button-border mr-2"
        @click="$emit('close-modal')"
      >
        Close
      </button>
      <button
        class="button-blue"
        @click="addIndexes"
      >
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    columns: {
      type: Array,
      default: () => null,
    },
  },

  data() {
    return {
      dataSetup: [
        {
          column: null,
          type: 1,
        },
      ],
      sorts: [
        { id: 1, text: 'ASC' },
        { id: -1, text: 'DESC' },
      ],
      dropdownSortOpened: null,
    };
  },


  computed: {
    ...mapState('jStoreJoana', ['dataset_data']),
  },

  methods: {
    ...mapActions('jStoreJoana', ['setIndexes']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),

    async addIndexes() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const payload = {
          id: this.dataset_data.id,
          payload: {
            indexes: this.dataSetup,
          },
        };

        const res = await this.setIndexes(payload);
        if (!res.error) {
          this.$emit('close-modal');
          this.$emit('refresh-data');
        }
      }
    },

    openDropdownSort(index) {
      if (this.dropdownSortOpened !== null) {
        this.$refs[`column-sort-${this.dropdownSortOpened}`][0].$emit('close');
        if (this.dropdownSortOpened !== index) {
          this.dropdownSortOpened = index;
          this.$refs[`column-sort-${index}`][0].$emit('open');
        } else {
          this.dropdownSortOpened = null;
        }
      } else {
        this.dropdownSortOpened = index;
        this.$refs[`column-sort-${index}`][0].$emit('open');
      }
    },

    addField() {
      this.dataSetup.push({
        column: null,
        type: 1,
      });
    },

    validationOptions(option, index) {
      const columnExist = this.dataSetup.filter(data => data.column === option);
      if (columnExist.length > 1) {
        this.toggleProblem('Index column must be unique');
        setTimeout(() => {
          this.dataSetup[index].column = null;
        }, 150);
      }
    },
  },

  validations() {
    return {
      dataSetup: {
        $each: {
          column: { required },
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/joanadb/dataset/partials/modalAddIndexes.vue